import React from "react";
import styled from "styled-components";
import Slider1 from "../HomeSection2/slider1/Slider1";
import { H1 } from "../../../Assets/Styles/GlobleStyles/TextStyles";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function HomeSection2() {
  const theme = useTheme();
  const Title = styled(H1)`
  font-size: 50px;
  line-height: 112.4%;
  text-align: center;
  color: ${theme.palette.text.main};
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  margin: 0 auto;
  padding-bottom: 50px;

  @media (max-width: 1100px) {
    font-size: 45px;
    line-height: 110%;
  }
  
  @media (max-width: 975px) {
    font-size: 40px;
    line-height: 45px;
  }
  
  @media (max-width: 895px) {
    font-size: 38px;
    line-height: 42px;
  }
  
  @media (max-width: 855px) {
    letter-spacing: -0.01em;
    font-size: 35px;
    line-height: 40px;
    padding-bottom: 25px;
    }
  
  @media (max-width: 715px) {
    font-size: 30px;
    line-height: 35px;
    padding-bottom: 30px;
  }
  
  @media (max-width: 480px) {
    font-size: 26px;
    line-height: 32px;
    padding-bottom: 25px;
  }
  
  @media (max-width: 375px) {
    font-size: 24px;
    line-height: 30px;
    padding-bottom: 20px;
  }
  
  @media (max-width: 320px) {
    font-size: 22px;
    line-height: 28px;
    padding-bottom: 15px;
  }
`;

  return (
    // main div
    <Wrapper>
      <ContentWrapper>
        <Title>
          <b>
          <Box>
            <Box component="span" sx={{color : `${theme.palette.primary.main}`}}>Peace of Mind</Box> for Pet Owners
            </Box>
          </b>
        </Title>

        <Slider1 />
      </ContentWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: #ffffff;
  overflow: hidden;
  margin: 0 auto;
  width: 100%;
`;

const ContentWrapper = styled.div`
  padding: 50px 0px;
  margin: 0 auto;
  max-width: 1536px;
  
  @media (max-width: 940px) {
    padding: 30px 0px;
  }
  
  @media (max-width: 715px) {
    padding: 25px 15px;
  }
  
  @media (max-width: 480px) {
    padding: 20px 10px;
  }
  
  @media (max-width: 375px) {
    padding: 15px 8px;
  }
  
  @media (max-width: 320px) {
    padding: 10px 5px;
  }
`;

